import { useCallback, useState } from 'react';

import {
  ServiceRowCard,
  ServiceRowCardVariant,
  ConditionView,
  ContentField,
  Typography,
  Button,
  ButtonVariant,
  Informer,
} from '@/shared/ui';

import { Weapon_v2, WeaponInformers } from '@/api/types';

import { WeaponDetailsModal } from '../';
import { informersText } from '../../uk.l10n';

interface WeaponListProps {
  weapons: Weapon_v2[];
  informers: WeaponInformers[];
  resetFilters: () => void;
}

export const WeaponList: React.FC<WeaponListProps> = ({ weapons, informers, resetFilters }) => {
  const [selectedWeapon, setSelectedWeapon] = useState<Nullable<Weapon_v2>>(null);

  const handleModalClose = useCallback(() => setSelectedWeapon(null), []);

  const handleWeaponClick = useCallback((weapon: Weapon_v2) => {
    setSelectedWeapon(weapon);
  }, []);

  return (
    <section className="weapon-registered__list">
      <ConditionView
        if={!!weapons && weapons.length > 0}
        else={
          <ContentField
            icon="no_result"
            content={
              <>
                <Typography color="graphite">За результатами фільтрації не знайдено жодної зброї</Typography>
                <Button variant={ButtonVariant.GHOST} onClick={resetFilters}>
                  Очистити фільтри
                </Button>
              </>
            }
          />
        }
      >
        {informers &&
          informers.map((informerName) => (
            <Informer
              key={informerName}
              header={{
                text: informersText[informerName].header,
                color: 'red',
              }}
              text={{
                text: informersText[informerName].text,
                color: 'black',
              }}
              icon={{ name: 'attention', color: 'red' }}
              bgColor="sand"
              borderColor="dark-yellow"
            />
          ))}

        {weapons?.map((weapon) => (
          <ServiceRowCard
            variant={ServiceRowCardVariant.WEAPON_REGISTERED}
            data={weapon}
            key={weapon.id}
            onDetailedClick={(): void => handleWeaponClick(weapon)}
          />
        ))}
      </ConditionView>
      {selectedWeapon && <WeaponDetailsModal selectedWeapon={selectedWeapon} handleModalClose={handleModalClose} />}
    </section>
  );
};
